export const MESSAGE_DISPLAYED = 'Message Displayed'
